import styled, { keyframes, css } from "styled-components";

const shakeAnimation = keyframes`
0% { transform: translateX(0); }
25% { transform: translateX(-3px); }
75% { transform: translateX(3px); }
100% { transform: translateX(0); }
`;

export const ModuleContainer = styled.div`
  display: flex;
  flex-direction: column;

  /* animation: ${({ isEditing }) =>
    isEditing
      ? css`
          ${shakeAnimation} 0.4s ease-in-out infinite
        `
      : "none"};
      */
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  border: 2px solid #eb5757;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ccc;
  position: relative;
`;

export const IconContainer = styled.div`
  background-color: #eb5757;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin-right: 1rem;
`;

export const IconStyle = {
  color: "inherit",
  fontSize: "24px",
};

export const ExtentionContainer = styled.div`
  height: 20rem;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: gainsboro;
    border-radius: 6px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: #212326;
    border-radius: 6px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #000;
  }
`;

//? Delayed Workers Module Configuration

export const WorkerContainer = styled.div`
  margin-top: 0.6rem;
  display: flex;
  width: 98%;
  height: 4rem;
  background-color: #fff;

  box-shadow: 0px 5.62941px 11.2588px rgba(88, 94, 102, 0.08);
  border-radius: 4.22206px;

  user-select: none;
  cursor: pointer;

  &:hover {
    background: #cff8e7;
  }

  transition: 0.15s ease-in-out background;
`;

export const Icon = styled.div`
  display: flex;

  width: 18%;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 2.25rem;
    border-radius: 50%;
    border: 1px solid #40e5a0;
  }

  path {
    stroke: #a9aeb4;
  }
`;

export const WorkerName = styled.span`
  width: 60%;
  align-items: center;
  display: flex;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  cursor: pointer;
`;

export const WStatusSpace = styled.div`
  width: 20%;
  align-items: center;
  display: flex;
`;

export const WorkDelayedCount = styled.span`
  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;
  background-color: #ffbaab;
  color: #d93333;
`;

export const RefreshDeleteContainer = styled.div`
  position: absolute;
  right: 5px;
  top: 0px;
`;
